import React, { useState, useEffect } from "react";
import {
    Button,
    Chip,
    colors,
    Container,
    Grid,
    Hidden,
    makeStyles,
    Paper,
    Typography,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import {
    useStylesCAB,
    useStylesContainers,
    useStylesDPM,
    useStylesHed,
    useStylesSpDial,
    useStylesUiElemment,
} from "../../../St/comps/UseStyle";
import { insh as inshst } from "../../../Context/InshSt";
import clsx from "clsx";

import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import i18next from "i18next";
import { TableChart } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import moment from "moment";
import axios from "axios";
import toast from "react-hot-toast";
import { sto } from "../../../Context/InshData";
import DeleteConfirmDialog from "../../../components/DeleteConfirmDialog";
import { uri } from "../../../help/Api";
import { useStylesBA } from "../../../St/comps/UseStyle";
import { insh, wsto } from "../../../Context/InshData";
import DiscountCodeForm from "./DiscountCodeForm";
import DiscountCodeTable from "./DiscountCodeTable";
import PumpsAppbar from "../Pumps/PumpsAppbar";


const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        backgroundColor: colors.red[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: colors.red[50],
        borderColor: colors.red[300],
    },
}));

const discType= [
    { id: 1, name: "مبلغ " },
    { id: 2, name: "نسبة" },,
  ];
export default function DiscountCode(props) {
    const { AutoOptions,
    } = props;
    const clasess = useStyles();
    // setBranch(defaultBranch);
    const valueCode = {
        id: AutoOptions?.other?.lastid ?? 1,
        code: "",
        type:1,
        monay:'',
        rate:'',
        IS_Deleted:false,
        start_date:moment(new Date()).format('YYYY-MM-DD'),
        end_date:moment(new Date()).format('YYYY-MM-DD'),
        branch:  sto.branchi,
        count: 0,
        db_name:sto?.db_name,
    };
    const AutoValuePupms = {
        type: discType[0],
    };
    const clasCAB = useStylesCAB();
    const [loading, setLoading] = useState(insh.LoadAndSucc);
    const [success, setSuccess] = useState(insh.LoadAndSucc);
    const classes = useStyles();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    const [data, setData] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [prevent, setPrevent] = React.useState(true);
    const [rptParams, setRptParams] = React.useState(valueCode);
    const [uiElement, setUiElement] = useState({});

    const [rptParamsAuto, setRptParamsAuto] = React.useState(AutoValuePupms);
    const clasBA = useStylesBA();

    const [discountReports, setDiscountReports] = React.useState(AutoOptions?.DiscountCode);


    const { t } = useTranslation(["forms", "translation"]);
    const ButtonLoading = (prop) => setLoading({ ...loading, [prop]: true });

    const timer = React.useRef();
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false });
    const [setting, setSetting] = useState({
        screen: "",
        tb: { parms: {}, autos: {} },
    });

    const [style, setStyle] = useState({});
    const his = useHistory();

    const buttonClassnameNew = clsx({ [clasCAB.buttonSuccessCAB]: success?.new });
    const buttonClassnameSave = clsx({
        [clasCAB.buttonSuccessCAB]: success.save,
    });
    const buttonClassnameDelete = clsx({
        [clasCAB.buttonSuccessCAB]: success.delete,
    });

    const backHome = () => {
        his.push({ pathname: "/" });
    };
    const back = () => {
        his.goBack();
    };
    const newToI = (timr) => {
        ButtonLoading("new");
        ButtonSuccess("new", timr);
        setPrevent(true);
    };


    const changTField = (prop) => (e) => {
        setRptParams({ ...rptParams, [prop]: e.target.value });
    };

    const onChangeAutoData = (propName, newValue) => {
        if (propName==="type"){
            if(newValue===1){
                setRptParams({ ...rptParams, [propName]: newValue.id ,rate:0});
                setRptParamsAuto({ ...rptParamsAuto, [propName]: newValue });
            }else{
                setRptParams({ ...rptParams, [propName]: newValue.id ,monay:0});
                setRptParamsAuto({ ...rptParamsAuto, [propName]: newValue });
            }
        }else{
            setRptParams({ ...rptParams, [propName]: newValue.id });
            setRptParamsAuto({ ...rptParamsAuto, [propName]: newValue });
        }

    };

    const onRowClick = async (row) => {
        setPrevent(false);
        let res = { type: {},  };
        discType.map((x) => {
            if (x.id == row.type) res.type = x;
        });
        setRptParamsAuto({
            ...AutoValuePupms,
            type: res.type,
        });

        setRptParams({
            ...rptParams,
            id: row.id,
            code: row.code,
            monay: row.monay,
            rate: row.rate,
            type: row.type,
            branch: row.branch,
            start_date:moment(row.start_date).format('YYYY-MM-DD'),
            end_date:moment(row.end_date).format('YYYY-MM-DD'),
        });
    };


    const reloadGets = async () => {
        const tb = {
            wait: true,
            other: true,
            DiscountCode: true,
            parms: {
                iempid: sto.empi,
                tname: "discount_code",
                branch: sto.branchi,
                db_name:sto?.db_name,
            },
        };

        await axios
            .post(uri + "GetD", tb)
            .then((res) => {
                setDiscountReports(res.data?.DiscountCode);
                setRptParams({
                    ...
                    valueCode,
                    id: res.data.other?.lastid
                });
                setRptParamsAuto(AutoValuePupms);
            })
            .catch((error) => {
            });
    };

    const handNewPumps = () => {
        reloadGets();
        setRptParamsAuto(AutoValuePupms);
        setRptParams(valueCode);
        setPrevent(true);
    };
    const ButtonSuccess = (prop, timr) => {
        timer.current = window.setTimeout(() => {
            setLoading({ ...loading, [prop]: false });
            setSuccess({ ...success, [prop]: true });
            if (prop === "save") { handNewPumps(); }
            if (prop === "update") { handNewPumps(); }

            else if (prop === "delete") { handNewPumps(); }
            else {
                handNewPumps();
            }
            setPrevent(true);
        }, 2000);
    };

    const addToBS = (props) => {
        ButtonLoading("save");
        if (rptParams.code !== "" && rptParams.code != null &&(parseFloat(rptParams.monay)>0|| parseFloat(rptParams.rate)>0)) {
            prevent
                ? axios
                    .post(uri + "DiscountCode", rptParams)
                    .then((res) => {
                        if (res.data?.data != null) {
                            ButtonSuccess("save", 1000);
                            toast.success("تمت عملية الحفظ بنجاح");
                        } else {
                            ButtonSuccess("save", 1000);
                            toast.success("تمت عملية الحفظ بنجاح");
                        }
                    })
                    .catch((res) => {
                        ButtonSuccess("save", 1000);
                        toast.error("خطا في عملية الحفظ ");

                    })
                :
                axios
                    .put(uri + "DiscountCode", rptParams)
                    .then((res) => {
                        ButtonSuccess("update", 1000);
                        toast.success("تمت عملية التعديل بنجاح");
                    })
                    .catch((res) => {
                        ButtonSuccess("update", 1000);
                        toast.error("خطا في عملية التعديل");

                    });
        } else {
            alert("تأكد من اكمال البيانات  ");
        }
    };



    const handleDeleteRow = async (e, row) => {
        await e.preventDefault();
        setConfirmDialog({ ...confirmDialog, isOpen: false });
        ButtonLoading("delete");
        let Urls = null;
        if (sto.db_name === "" || sto.db_name === null) {
          Urls = `DiscountCode?id=${row?.id}`
        } else {
          Urls = `DiscountCode?id=${row?.id}&&db_name=${sto?.db_name}`
        }
        await axios.delete(uri + Urls).then(res => {
            if (res.data==="no"){
                alert("You Cant delete this Pump.."); 
            }else{
                toast.success("تم الحذف بنجاح");
                ButtonSuccess("delete", 1000);
            }

        }).catch(err => {
            console.log("eror", err)
            ButtonSuccess("delete", 1000);
            toast.error("not delete ")
        })
    };

    const deleteToI = async (e) => {
        await e.preventDefault();
        setConfirmDialog({ ...confirmDialog, isOpen: false });
        ButtonLoading("delete");
        let Urls = null;
        if (sto.db_name === "" || sto.db_name === null) {
          Urls = `DiscountCode?id=${rptParams?.id}`
        } else {
          Urls = `DiscountCode?id=${rptParams?.id}&&db_name=${sto?.db_name}`
        }
        await axios.delete(uri +Urls).then(res => {
            toast.success("تم الحذف بنجاح");
            ButtonSuccess("delete", 1000);
        }).catch(err => {
            console.log("eror", err)
            ButtonSuccess("delete", 1000);
            toast.error("not delete ")
        })
    };
    return (
        <div className={classes.root}>
            <Grid container item xs={12}>
                <Typography
                    size="small"
                    className={classes.headerTitle}
                    style={{ backgroundColor: colors.red[50], fontWeight: "bold" }}
                    color="primary"
                >
                    {"تعريف كود الخصم"}
                </Typography>
            </Grid>
            <Typography
                component="div"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
            >
                <Grid container item lg={12} md={12} sm={12} xm={12}className={clasui.rootchip} >

                    <Grid container item lg={6} md={6} sm={6} xm={12} className={clasui.rootchip} >

                        <Container
                            component={Paper}
                            maxWidth={false}
                            style={{
                                padding: "10px",
                                paddingBottom: "0px",
                                borderBottomColor: colors.green[300],
                                borderBottomWidth: "1px",
                                borderBottomStyle: "solid",
                            }}
                        >
                            <DiscountCodeForm
                                {...{
                                    rptParams,
                                    rptParamsAuto,
                                    onChangeAutoData,
                                    changTField,
                                    discType
                                }}
                            />

                        </Container>
                    </Grid>
                    <Grid container lg={6} md={6} sm={6} xm={12} className={clasui.rootchip}>
                        <Container
                            component={Paper}
                            maxWidth={false}
                            style={{
                                padding: "10px",
                                marginTop: "0.5rem"
                            }}
                        >
                            <Grid container justifyContent="center">
                                <Grid item container justifyContent="center" xs={12}>
                                    <BeatLoader loading={fetching} color={colors.red[300]} />
                                    {!fetching && (
                                        <DiscountCodeTable
                                            {...{
                                                data: discountReports ? discountReports : [],
                                                setConfirmDialog,
                                                handleDeleteRow,
                                                onRowClick
                                            }}
                                        />
                                    )}
                                </Grid>
                            </Grid>
                        </Container>
                    </Grid>
                </Grid>
                <DeleteConfirmDialog
                    confirmDialog={confirmDialog}
                    setConfirmDialog={setConfirmDialog}
                />
            </Typography>
            <PumpsAppbar {...{
                rptParams,
                buttonClassnameNew,
                buttonClassnameSave,
                buttonClassnameDelete,
                clasCAB,
                newToI,
                setting,
                deleteToI,
                addToBS,
                loading,
                clasBA,
                backHome,
                back,
                uiElement,
                prevent
            }}
            />
        </div>
    );
}
